/** TanStack Query keys of the onboarding chat, so a mutation can set or invalidate exactly what it changed. */
export const onboardingKeys = {
  all: ['onboarding'] as const,
  snapshot: (sessionId: string) => ['onboarding', 'snapshot', sessionId] as const,
  brandGuide: (sessionId: string) => ['onboarding', 'brand-guide', sessionId] as const,
  adAccounts: (sessionId: string) => ['onboarding', 'ad-accounts', sessionId] as const,
  /** Every platform's analysis of a session (a prefix of `adAnalysis`). */
  adAnalysisAll: (sessionId: string) => ['onboarding', 'ad-analysis', sessionId] as const,
  adAnalysis: (sessionId: string, platform: string) => ['onboarding', 'ad-analysis', sessionId, platform] as const,
  funnel: (sessionId: string) => ['onboarding', 'funnel', sessionId] as const,
  /** How many slow re-reads of a funnel whose scorecard failed in passing were spent (a number kept in the cache, so it survives a remount). */
  funnelScorecardPolls: (sessionId: string) => ['onboarding', 'funnel-scorecard-polls', sessionId] as const,
  assessment: (sessionId: string) => ['onboarding', 'assessment', sessionId] as const,
  competitors: (sessionId: string) => ['onboarding', 'competitors', sessionId] as const,
};
